import { getBasicInfoFromVideo, selectFile } from "@/utils";
import styles from "./index.module.scss";
import { UploadSvg } from "@/assets/icons";
import { useCommonStore } from "@/stores";
import { MIN_DURATION, PROJECT_TYPE } from "@/constants";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import FTAnalytic from "@/analyze/FTAnalytic";
import { useState } from "react";
import Loading from "../loading";

const ExpTempUploader = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const generating = useCommonStore(state => state.generating);
  const handling = useCommonStore(state => state.getters.handling);
  const addCusExpTemp = useCommonStore(state => state.addCusExpTemp);
  const setVideoEditorOptions = useCommonStore(state => state.setVideoEditorOptions);

  const handleClick = async () => {
    setLoading(true);
    const { default: FFmpegUtil } = await import("@/utils/FFmpegUtil");
    setLoading(false);
    
    if (FFmpegUtil.handling) return;

    // 埋点
    FTAnalytic.addAnalytic({
      type: 'ev',
      action: 'fotor_web$click_up$swap_project_page_features',
      label: {
        button_position: "upload",
        project_type: PROJECT_TYPE,
      },
    });

    selectFile({ accept: "video/*" })
      .then((files: any) => {
        const file = files[0];
        getBasicInfoFromVideo(file)
          .then(info => {
            const { duration } = info;
            if (duration < MIN_DURATION) {
              addCusExpTemp(file);
            } else {
              setVideoEditorOptions({
                show: true,
                video: file,
                onResult: (value: File) => {
                  addCusExpTemp(value);
                  setVideoEditorOptions({ show: false });
                }
              })
            }
          })
          .catch(err => {
            console.error(err);
            toast("invalid file");
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <div
      className={styles["exp_temp_uploader"]}
    >
      <button
        className={styles["uploader_button"]}
        disabled={generating || handling || loading}
        onClick={handleClick}
      >
        {loading ? (
          <Loading isBlack></Loading>
        ) : (
          <>
            <UploadSvg></UploadSvg>
            <span
              className="two_line_ellipsis"
            >
              {t("upload_exp_button")}
            </span>
          </>
        )}
      </button>
    </div>
  )
}

export default ExpTempUploader;